<template>
    <div class="single-member__holder marquee__holder background-image-holder" v-if="result && result.teanMembers.data.length > 0" id="content">

        <router-link class="general-button transparent-background" to="/agency">
            <span class="general-icon">
                <arrow-right />
            </span>
            Back to Agency
        </router-link>

        <div class="small-wrapper">

            <div class="single-member grid two">

                <figure class="single-member__image-mobile" v-if="result.teanMembers.data[0].attributes.Image?.data?.attributes?.url">
                    <SafeImage 
                        :imageData="result.teanMembers.data[0].attributes.Image"
                        :placeholder="PLACEHOLDER_IMAGES.TEAM_MEMBER"
                        placeholderText="Team member photo not available"
                        imageClass="single-member-mobile-image"
                    />
                </figure>

                <div class="single-member__content">
                    <h1 class="single-member__name">
                        {{ result.teanMembers.data[0].attributes.firstName }} {{ result.teanMembers.data[0].attributes.lastName }}
                    </h1>

                    <div class="single-member__position">
                        {{ result.teanMembers.data[0].attributes.position }}
                    </div>

                    <div class="single-member__known">
                        Known for
                        <div class="single-member__known__text">
                            {{ result.teanMembers.data[0].attributes.knownFor }}
                        </div>
                    </div>

                    <div class="single-member__description" v-html="result.teanMembers.data[0].attributes.Description">

                    </div>
                </div>

                <div class="single-member__image">
                    <figure v-if="result.teanMembers.data[0].attributes.Image?.data?.attributes?.url">
                        <SafeImage 
                            :imageData="result.teanMembers.data[0].attributes.Image"
                            :placeholder="PLACEHOLDER_IMAGES.TEAM_MEMBER"
                            placeholderText="Team member photo not available"
                            imageClass="single-member-desktop-image"
                        />


                        <!-- <div class="badge-button" >
                            <span   class="badge-button__content"
                                    v-for="(image, index) in result.teanMembers.data[0].attributes.badgeIcon.data"
                                    :key="index">
                                <img :src="image.attributes.url" :alt="image.attributes.alternativeText"/>
                            </span>
                            <span class="badge-button__rain rotate-badge">
                <badge-icon/>
                            </span>
                        </div> -->
                    </figure>

                </div>

            </div>

        </div>

        <div class="marquee">
            {{result.teanMembers.data[0].attributes.marqueeText}}/{{result.teanMembers.data[0].attributes.marqueeText}}/{{result.teanMembers.data[0].attributes.marqueeText}}/{{result.teanMembers.data[0].attributes.marqueeText}}
        </div>


        <span class="contact-noise"></span>

        <span class="single-member-background"></span>

        <Seo v-if="result && result.teanMembers.data.length > 0 && result.teanMembers.data[0].attributes.seo" :seoData="result.teanMembers.data[0].attributes.seo"/>

    </div>
</template>

<script lang="ts">

    import { defineComponent, ref, onMounted, Ref, watch } from 'vue';
    import { useQuery } from '@vue/apollo-composable';
    import { SINGLE_TEAM_MEMBER_BY_SLUG } from '../../graphql/single-team-member-by-slug';

    import SafeImage from '../../components/SafeImage.vue'
    import { PLACEHOLDER_IMAGES } from '../../composables/useImageErrorHandler'

    import ArrowRight from "../../components/svg/ArrowRight.vue"
    import BadgeIcon from "../../components/svg/BadgeIconBg.vue"
    import SingleQuitar from "../../components/svg/SingleQuitar.vue"
    import SingleSquares from "../../components/svg/SingleSquares.vue"
    import Seo from '../../components/navigation/Seo.vue'

    import SingleMemberBackground from "../../components/svg/SingleMemberBackground.vue"



    function updateBadgeClass(badges: HTMLElement[], showImageClass: string, currentIndex: Ref<number>) {
        const totalBadges = badges.length;

        // Check if badges array is empty or contains undefined elements
        if (totalBadges === 0 || !badges[currentIndex.value]) {
            return;
        }

        // Remove "show-image" class from all badges
        badges.forEach((badge) => {
          if (badge && badge.classList) {
            badge.classList.remove(showImageClass);
          }
        });

        // Add "show-image" class to the current badge
        if (badges[currentIndex.value] && badges[currentIndex.value].classList) {
            badges[currentIndex.value].classList.add(showImageClass);
        }

        // Increment the current index or reset to 0 if it exceeds the total count
        currentIndex.value = (currentIndex.value + 1) % totalBadges;
    }

    export default defineComponent({
        components:{
            SafeImage,
            ArrowRight,
            BadgeIcon,
            SingleQuitar,
            SingleSquares,
            Seo,
            SingleMemberBackground
        },
        props: {
            teamMemberSlug: {
                type: String,
                required: true,
            },
        },
        setup(props) {
            const homeurl: string = import.meta.env.VITE_API_URL;
            const teamMember = ref(null);
            const { result, loading } = useQuery(SINGLE_TEAM_MEMBER_BY_SLUG, {
                slug: props.teamMemberSlug,
            });

            const currentIndex = ref(0);
            const badges = ref<HTMLElement[]>([]);
            const showImageClass = 'show-image';

            // Watch for query completion and redirect if no results
            watch([result, loading], ([newResult, newLoading]) => {
                if (!newLoading && newResult && newResult.teanMembers && newResult.teanMembers.data.length === 0) {
                    // Use window.location for hard redirect to ensure proper page load
                    window.location.href = '/404';
                }
            }, { immediate: true });

            onMounted(() => {
                if (!loading.value && result.value?.teanMembers?.data?.length > 0) {
                    teamMember.value = result.value.teanMembers.data[0].attributes;
                }
                setTimeout(() => {
                    const badgeElements = document.querySelectorAll('.badge-button__content');
                    badges.value = Array.from(badgeElements) as HTMLElement[];
                    
                    // Only start the badge rotation if badges exist
                    if (badges.value.length > 0) {
                        updateBadgeClass(badges.value, showImageClass, currentIndex);
                        setInterval(() => updateBadgeClass(badges.value, showImageClass, currentIndex), 5000);
                    }
                }, 500);
            });

            return {
                result,
                teamMember,
                homeurl,
                PLACEHOLDER_IMAGES
            };
        },
    });

</script>
